import BaseModel from './base';

export default class Profile extends BaseModel {
  constructor(profile, url) {
    super(profile, url);

    this.avatar = profile.avatar || {};

    this.municipality_name = profile.municipality_name || profile?.municipality?.name || '-';
    this.region_name = profile.region_name || profile?.region?.name || '-';

    this.region = profile.region || null;
    this.municipality = profile.municipality || null;
  }
}
